export default __webpack_public_path__ + "assets/img/ict-undo.07a9a7fa09b0809a5b16bb7af79bb6c2.svg";